import type { MESSAGE_STATUS } from '../enums';
import type { SortChanges } from '../sort.type';
import type { PagedListRequest } from './pagedListRequest.type';

export enum MESSAGES_LIST_SORT_FIELD {
  CREATED_DATE = 'created_date',
  SENT_DATE = 'sent_date',
}

export enum MESSAGES_LIST_PRODUCT {
  MPA = 'mpa',
}

export type MessagesListRequestFiltersData = Partial<SortChanges<MESSAGES_LIST_SORT_FIELD>> &
  PagedListRequest & {
    term?: string;
    status?: MESSAGE_STATUS;
    isInbox?: boolean;
    groupIds?: string[];
    from?: string;
    to?: string;
    product?: MESSAGES_LIST_PRODUCT;
  };
